import { timePickerDefaultProps } from '@jdesign-vue/components/time-picker'
import { buildProps, definePropType } from '@jdesign-vue/utils'

import type { ExtractPropTypes } from 'vue'
import type { IDatePickerType } from '../date-picker.type'

export const datePickerProps = buildProps({
  ...timePickerDefaultProps,
  type: {
    type: definePropType<IDatePickerType>(String),
    default: 'date',
  },
  clearOnClose: {
    type: Boolean,
  },
  rangeLimit: {
    type: Number,
  },

} as const)

export type DatePickerProps = ExtractPropTypes<typeof datePickerProps>
